import { createSlice } from "@reduxjs/toolkit";
import {getAuthUser} from "../../utils";

const initialState = {
    category: "",
    search:""
}

const searchSlice = createSlice({
    initialState,
    name: "searc-bar",
    reducers: {
        set_search: (state, action) => {
            state.search = action.payload;
            return state
        },
        set_selected_file_type :(state,action)=>{
            state.category = action.payload;
            return state
        },
        reset_search_bar :(state,action) =>{
            state = initialState
            return state
        }
    }
})

export default searchSlice.reducer;

export const {
    set_search,
    set_selected_file_type,
    reset_search_bar
} = searchSlice.actions;
